module.exports = __webpack_public_path__ + "static/media/ic-x-bold-white.6993e7a6.svg";